export class UsageHelper {
    /**
     * Get two first characters of usage
     * @param {string} usage
     * @return {string}
     */
    public static extractUsageCodeFromUsage(usage: string): string {
        return usage.slice(0, 2);
    }

    /**
     * Check usage format
     *  both usage on 2 or 5 digits
     * @param {string} usage
     * @returns {boolean}
     */
    public static isUsageWellFormatted(usage: string): boolean {
        return new RegExp(/^(11|2[12]|3[13]|4[1-68]|5[1-6])(?:\d{3})?$/).test(usage);
    }

    /**
     * Check that usage (5 digits) is primary usage (ends with 1)
     * @param {string} usage
     * @returns {boolean}
     */
    public static isPrimary(usage: string): boolean {
        return Number(usage.substring(2, 5)) === 1;
    }
}
